/**
 * @external UserActivation
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/UserActivation}
 * @see {@link https://stackoverflow.com/a/76001567}
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/Security/User_activation}
 */

(function () {
    'use strict';

    if (!navigator.userActivation) {
        navigator.userActivation = { hasBeenActive: false };
        let pageActivationClickHandler = (e) => {
            if (e.isTrusted) {
                navigator.userActivation.hasBeenActive = true;
                window.removeEventListener('keydown', pageActivationClickHandler);
                window.removeEventListener('mousedown', pageActivationClickHandler);
                window.removeEventListener('pointerdown', pageActivationClickHandler);
                window.removeEventListener('pointerup', pageActivationClickHandler);
                window.removeEventListener('touchend', pageActivationClickHandler);
            }
        };
        window.addEventListener('keydown', pageActivationClickHandler);
        window.addEventListener('mousedown', pageActivationClickHandler);
        window.addEventListener('pointerdown', pageActivationClickHandler);
        window.addEventListener('pointerup', pageActivationClickHandler);
        window.addEventListener('touchend', pageActivationClickHandler);
    }
})();
